export default {
  checkInterval: 'checkInterval',
  newCommitCheckInterval: 'New commit check interval',
  schedule: 'Schedule',
  newSchedule: 'New Schedule',
  deleteSchedule: 'Delete Schedule',
  editSchedule: 'Edit Schedule',
  backup: 'Backup Project',
  downloadTheProjectBackupFile: 'Download the project backup file.',
  restoreProject: 'Restore Project...',
  incorrectUsrPwd: 'Incorrect login or password',
  askDeleteUser: 'Do you really want to delete this user?',
  askDeleteTemp: 'Do you really want to delete this template?',
  askDeleteEnv: 'Do you really want to delete this environment?',
  askDeleteInv: 'Do you really want to delete this inventor?',
  askDeleteKey: 'Do you really want to delete this key?',
  askDeleteRepo: 'Do you really want to delete this repository?',
  askDeleteProj: 'Do you really want to delete this project?',
  askDeleteTMem: 'Do you really want to delete this team member?',
  askDeleteSchedule: 'Do you really want to delete this schedule?',
  edit: 'Edit',
  nnew: 'New',
  keyFormSshKey: 'SSH Key',
  keyFormLoginPassword: 'Login with password',
  keyFormNone: 'None',
  incorrectUrl: 'Incorrect URL',
  username: 'Username',
  username_required: 'Username is required',
  dashboard: 'Dashboard',
  history: 'History',
  activity: 'Activity',
  settings: 'Settings',
  signIn: 'Sign In',
  password: 'Password',
  changePassword: 'Change password',
  editUser: 'Edit User',
  newProject: 'New Project',
  close: 'Close',
  newProject2: 'New Project...',
  demoMode: 'DEMO MODE',
  task: 'Task #{expr}',
  youCanRunAnyTasks: 'You can run any tasks',
  youHaveReadonlyAccess: 'You have read-only access',
  taskTemplates: 'Task Templates',
  inventory: 'Inventory',
  environment: 'Variable Groups',
  keyStore: 'Key Store',
  repositories: 'Repositories',
  darkMode: 'Dark Mode',
  team: 'Team',
  more: 'More',
  pin: 'Pin to sidebar',
  unpin: 'Unpin from sidebar',
  editMenu: 'Edit menu',
  finishEditingMenu: 'Done',
  users: 'Users',
  editAccount: 'Edit Account',
  signOut: 'Sign Out',
  error: 'Error',
  refreshPage: 'Refresh Page',
  relogin: 'Relogin',
  howToFixSigninIssues: 'How to fix sign-in issues',
  firstlyYouNeedAccessToTheServerWhereSemaphoreRunni:
    'Firstly, you need access to the server where Semaphore running.',
  executeTheFollowingCommandOnTheServerToSeeExisting:
    'Execute the following command on the server to see existing users:',
  semaphoreUserList: 'semaphore user list',
  youCanChangePasswordOfExistingUser: 'You can change password of existing user:',
  semaphoreUserChangebyloginLoginUser123Password:
    'semaphore user change-by-login --login user123 --password {makePasswordExample}',
  orCreateNewAdminUser: 'Or create new admin user:',
  close2: 'Close',
  semaphore: 'SEMAPHORE',
  dontHaveAccountOrCantSignIn: "Don't have account or can't sign in?",
  password2: 'Password',
  currentPassword: 'Current password',
  cancel: 'Cancel',
  noViews: 'No views',
  addView: 'Add view',
  editEnvironment: 'Edit Variable Group',
  deleteEnvironment: 'Delete variable group',
  newEnvironment: 'New Group',
  environmentName: 'Group Name',
  dockerImage: 'Runner Docker Image (optional)',
  extraVariables: 'Extra variables',
  enterExtraVariablesJson: 'Enter extra variables JSON...',
  environmentVariables: 'Environment variables',
  enterEnvJson: 'Enter env JSON...',
  environmentAndExtraVariablesMustBeValidJsonExample:
    'Environment and extra variables must be valid JSON. Example:',
  dashboard2: 'Dashboard',
  ansibleSemaphore: 'Semaphore UI',
  wereSorryButHtmlwebpackpluginoptionstitleDoesntWor:
    "We're sorry but <%= htmlWebpackPlugin.options.title %> doesn't work properly without JavaScript enabled. Please enable it to continue.",
  deleteInventory: 'Delete inventory',
  newInventory: 'New Inventory',
  name: 'Name',
  userCredentials: 'User Credentials',
  sudoCredentialsOptional: 'Sudo Credentials (Optional)',
  type: 'Type',
  pathToInventoryFile: 'Path to Inventory file',
  enterInventory: 'Enter inventory...',
  staticInventoryExample: 'Static inventory example:',
  staticYamlInventoryExample: 'Static YAML inventory example:',
  keyName: 'Key Name',
  loginOptional: 'Login (Optional)',
  usernameOptional: 'Username (Optional)',
  privateKey: 'Private Key',
  override: 'Override',
  useThisTypeOfKeyForHttpsRepositoriesAndForPlaybook:
    'Use this type of key for HTTPS repositories and for playbooks which use non-SSH connections.',
  deleteKey: 'Delete key',
  newKey: 'New Key',
  create: 'Create',
  newTask: 'New Task',
  cantDeleteThe: "Can't delete the {objectTitle}",
  theCantBeDeletedBecauseItUsedByTheResourcesBelow:
    "The {objectTitle} can't be deleted because it used by the resources below",
  projectName: 'Project Name',
  allowAlertsForThisProject: 'Allow alerts for this project',
  telegramChatIdOptional: 'Telegram Chat ID (Optional)',
  maxNumberOfParallelTasksOptional: 'Max number of parallel tasks (Optional)',
  deleteRepository: 'Delete repository',
  newRepository: 'New Repository',
  urlOrPath: 'URL or path',
  absPath: 'abs. path',
  branch: 'Branch / Tag',
  accessKey: 'Access Key',
  credentialsToAccessToTheGitRepositoryItShouldBe:
    'Credentials to access to the Git repository. It should be:',
  ifYouUseGitOrSshUrl: 'if you use Git or SSH URL.',
  ifYouUseHttpsOrFileUrl: 'if you use HTTPS or file URL.',
  none: 'None',
  ssh: 'SSH',
  deleteProject: 'Delete project',
  save: 'Save',
  deleteProject2: 'Delete Project',
  onceYouDeleteAProjectThereIsNoGoingBackPleaseBeCer:
    'Once you delete a project, there is no going back. Please be certain.',

  clear_cache: 'Clear cache',
  clear_cache_message:
    'Delete all cache files related to this project. This action is irreversible.',

  name2: 'Name *',
  title: 'Title *',
  description: 'Description',
  required: 'Required',
  key: '{expr}',
  surveyVariables: 'Survey Variables',
  addVariable: 'Add variable',
  vaultName: 'Vault ID (optional)',
  vaultNameDefault: 'Only one `default` (empty) name may exist',
  default_value: 'Default value',
  vaultNameUnique: 'Must be unique',
  vaultTypePassword: 'Password',
  vaultTypeScript: 'Client Script',
  vaultScript: 'Script Path',
  vaultScriptRequired: 'Script Path is required',
  vaultScriptClientRequired: "Script path must end with '-client' and extension",
  vaults: 'Vaults',
  vaultAdd: 'Add Vault',
  vaultRequired: 'Vault Password is required',
  columns: 'Columns',
  buildVersion: 'Build Version',
  messageOptional: 'Message (Optional)',
  debug: 'Debug',
  dryRun: 'Dry Run',
  diff: 'Diff',
  advanced: 'Advanced',
  hide: 'Hide',
  pleaseAllowOverridingCliArgumentInTaskTemplateSett:
    'To allow overriding CLI argument in Task Template settings',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe:
    'CLI Args (JSON array). Example: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  started: 'Started',
  author: 'Author',
  duration: 'Duration',
  stop: 'Stop',
  forceStop: 'Force Stop',
  stopAll: 'Stop All',
  stopAllTasks: 'Stop All Tasks',
  askStopAllTasks: 'Are you sure you want to stop all tasks?',
  forceStopAllTasks: 'Force Stop All Tasks',
  askForceStopAllTasks: 'Are you sure you want to force stop all tasks?',
  raw_log: 'Raw log',

  confirmTask: 'Confirm',
  deleteTeamMember: 'Delete team member',
  team2: 'Team',
  newTeamMember: 'New Team Member',
  user: 'User',
  administrator: 'Administrator',
  definesStartVersionOfYourArtifactEachRunIncrements:
    'Defines start version of your artifact. Each run increments the artifact version.',
  forMoreInformationAboutBuildingSeeThe: 'For more information about building, see the',
  taskTemplateReference: 'Task Template reference',
  definesWhatArtifactShouldBeDeployedWhenTheTaskRun:
    'Defines what artifact should be deployed when the task run.',
  forMoreInformationAboutDeployingSeeThe: 'For more information about deploying, see the',
  taskTemplateReference2: 'Task Template reference',
  definesAutorunSchedule: 'Defines autorun schedule.',
  forMoreInformationAboutCronSeeThe: 'For more information about cron, see the',
  cronExpressionFormatReference: 'Cron expression format reference',
  startVersion: 'Start Version',
  example000: 'Example: 0.0.0',
  buildTemplate: 'Build Template',
  autorun: 'Autorun',
  playbookFilename: 'Path to playbook file *',
  exampleSiteyml: 'Example: deploy/site.yml',
  inventory2: 'Inventory *',
  repository: 'Repository',
  environment3: 'Variable Groups *',
  environmentsHint:
    'Variables from each selected group are merged in order; later groups override earlier ones on conflicts.',
  vaultPassword: 'Vault Password',
  vaultPassword2: 'Vault Password',
  view: 'View',
  cron: 'Cron',
  iWantToRunATaskByTheCronOnlyForForNewCommitsOfSome:
    'Auto-run task if new git commit have been found',
  repository2: 'Repository',
  cronChecksNewCommitBeforeRun: 'Cron checks new commit before run',
  readThe: 'Read the',
  toLearnMoreAboutCron: 'to learn more about Cron.',
  suppressSuccessAlerts: 'Suppress success notifications',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe2:
    'CLI Args (JSON array). Example: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  allowCliArgsInTask: 'CLI args',
  docs: 'docs',
  editViews: 'Edit Views',
  newTemplate: 'New template',
  taskTemplates2: 'Task Templates',
  all: 'All',
  notLaunched: 'Not launched',
  by: 'by {user_name}',
  editTemplate: 'Edit Template',
  newTemplate2: 'New Template',
  deleteTemplate: 'Delete template',
  playbook: 'Playbook',
  email: 'Email',
  adminUser: 'Admin user',
  sendAlerts: 'Send alerts',
  deleteUser: 'Delete user',
  newUser: 'New User',
  re: 'Re{getActionButtonTitle}',
  teamMember: '{expr} Team Member',
  taskId: 'Task ID',
  status: 'Status',
  start: 'Start',
  actions: 'Actions',
  alert: 'Alert',
  admin: 'Admin',
  role: 'Role',
  external: 'External',
  time: 'Time',
  path: 'Path',
  gitUrl: 'Git URL',
  sshKey: 'SSH Key',
  lastTask: 'Last Task',
  task2: 'Task',
  build: 'Build',
  deploy: 'Deploy',
  run: 'Run',
  add: 'Add',
  password_required: 'Password is required',
  name_required: 'Name is required',
  user_credentials_required: 'User credentials are required',
  type_required: 'Type is required',
  path_required: 'Path to Inventory file is required',
  private_key_required: 'Private key is required',
  project_name_required: 'Project name is required',
  repository_required: 'Repository is required',
  branch_required: 'Branch or tag is required',
  key_required: 'Key is required',
  user_required: 'User is required',
  build_version_required: 'Build version is required',
  title_required: 'Title is required',
  isRequired: 'is required',
  mustBeInteger: 'Must be integer',
  mustBe0OrGreater: 'Must be 0 or greater',
  start_version_required: 'Start version is required',
  playbook_filename_required: 'Playbook filename is required',
  inventory_required: 'Inventory is required',
  environment_required: 'Environment is required',
  email_required: 'Email is required',
  build_template_required: 'Build template is required',
  Task: 'Task',
  Build: 'Build',
  Deploy: 'Deploy',
  Run: 'Run',
  ReBuild: 'Rebuild',
  ReDeploy: 'Redeploy',
  ReRun: 'Rerun',
  CreateDemoProject: 'Create Demo Project',
  LeaveProject: 'Leave Project',
  integration: 'Integration',
  integrations: 'Integrations',
  NewIntegration: 'New Integration',
  EditIntegration: 'Edit Integration',
  DeleteIntegration: 'Delete Integration',
  DeleteIntegrationMsg: 'Are you sure you want to delete this Integration?',
  AddAlias: 'Add Alias',
  LoadAlias: 'Loading aliases...',
  globalAlias: 'Use project alias',
  matcher: 'Matcher',
  matchType: 'Match Type',
  newMatcher: 'New Matcher',
  matchMethod: 'Comparison Method',
  matchBodyDataType: 'Body Data Type',
  extractValue: 'Extract Value',
  newExtractedValue: 'New Extracted Value',
  extractedValueSource: 'Value Source',
  matchKey: 'Key',
  matchValue: 'Value',
  matchOn: 'Match on',
  global: 'Global',
  synchronized: 'synchronized',
  default: 'Default',
  project: 'Project',
  runners: 'Runners',
  clusterDashboard: 'HA Cluster Dashboard',
  clusterOverview: 'Overview',
  haEnabled: 'HA mode',
  haDisabledBanner: 'HA mode is disabled — showing the local task pool only.',
  nodes: 'Nodes',
  alive: 'Alive',
  dead: 'Dead',
  thisNode: 'this node',
  lastHeartbeat: 'Last heartbeat',
  startedAt: 'Started at',
  redisStatus: 'Redis',
  connected: 'Connected',
  usedMemory: 'Used memory',
  redisMemoryChart: 'Used memory (realtime)',
  totalKeys: 'Total keys',
  keyGroups: 'Key groups',
  taskRecords: 'Task Records',
  queue: 'Queue',
  running: 'Running',
  activeByProject: 'Active by project',
  aliases: 'Aliases',
  claims: 'Claims',
  owningNode: 'Node',
  clearTasksFromRedis: 'Clear Tasks from Redis',
  clearTasksTitle: 'Clear tasks from Redis',
  clearTasksWarning:
    'Clearing Running or Claims can desync cluster nodes. '
    + 'Use this only to recover from a stuck state.',
  clearTasksGroups: 'Select the record groups to clear:',
  runtimeFields: 'Runtime fields',
  newRunner: 'New Runner',
  enabled: 'Enabled',
  scheduleNextRun: 'Next run',
  maxNumberOfParallelTasks: 'Maximum parallel tasks',
  runnerUsage: 'Usage:',
  runnerDockerCommand: 'Docker:',
  runnerToken: 'Token:',
  editRunner: 'Edit Runner',
  deleteRunner: 'Delete Runner',
  newRunnerToken: 'New Runner',
  register: 'Register',
  unregisteredRunnerHint:
    'The runner will be created without any token. You can then generate a one-time '
    + 'registration token for it and use that to register the runner later.',
  runnerRegistrationToken: 'New Runner',
  registrationToken: 'Registration token:',
  registrationTokenHint:
    'This one-time token is shown only once and expires in 1 hour. '
    + 'Use it to register the runner.',
  howToRegister: 'How to register',
  runnerCreated: 'Runner created',
  regenerateRegistrationToken: 'Regenerate registration token',
  askResetRunnerRegistration:
    'This runner is registered. Regenerating the token will reset it: its current '
    + 'token stops working and the runner goes offline until it re-registers with '
    + 'the new token. Continue?',
  askDeleteRunner: 'Do you really want to delete runner {runner}?',
  roles_only_enterprise: 'Roles are only available in <b>Enterprise</b> edition.',
  ha_only_enterprise: 'High availability are only available in <b>Enterprise</b> edition.',
  project_runners_only_pro: 'Project-level runners are only available for <b>PRO</b> users.',
  secret_storage_only_pro: 'Secret storages are only available for <b>PRO</b> users.',
  foss_runners_limited:
    'The open-source version has limited functionality; full functionality is in the <b>PRO</b> version.',
  learn_more_about_pro: 'Learn more',
  upgrade_to_pro: 'Upgrade',
  contact_admin_to_upgrade: 'Contact your admin to activate PRO features.',
  contact_admin_to_upgrade_enterprise: 'Contact your admin to activate Enterprise features.',

  projectRestoreResult: 'Project restore results',
  projectWithNameRestored: 'Project {projectName} successfully restored.',
  pleaseUpdateAccessKeys: 'Please update them before running tasks.',
  emptyKeysRestored: '{emptyKeys} empty keys added.',
  template: 'Template',
  aliasUrlCopied: 'The alias URL has been copied to the clipboard.',
  yes: 'Yes',
  activeTasks: 'Active Tasks',
  taskLocation: 'Location',
  empty: 'Empty',
  noValues: 'No values',
  addArg: 'Add arg',

  status_success: 'Success',
  status_failed: 'Failed',
  status_stopped: 'Stopped',

  api_tokens: 'API Tokens',
  tokenName: 'Token Name',

  // Terraform/OpenTofu/Terragrunt
  auto_approve: 'Auto approve',
  auto_destroy: 'Allow destroy',
  terraform_override_backend: 'Override backend settings',
  terraform_backend_filename: 'Backend filename (default: backend.tf)',
  terraform_invalid_backend_filename: 'Invalid backend filename',

  // Ansible
  tag: 'Tag',
  tag_required: 'Tag is required',
  allowInventoryInTask: 'Inventory',
  allowLimitInTask: 'Limit',
  addLimit: 'Add limit',
  allowDebug: 'Debug',
  skipGalaxyInstall: 'Skip Galaxy install',
  addTag: 'Add tag',
  skipTags: 'Skip tags',
  addSkippedTag: 'Add skipped tag',
  tags: 'Tags',
  limit: 'Limit',

  runner_tag: 'Runner tag',
  allow_parallel_tasks: 'Allow parallel tasks',
  task_prompts: 'Prompts',
  template_advanced: 'Advanced options',
  template_app_options: '{app} options',
  template_app_prompts: '{app} prompts',
  general_settings: 'General',
  danger_zone_settings: 'Danger Zone',
  project_stats: 'Stats',
  allow_override_branch: 'Branch',
  template_common_options: 'Common options',

  template_tasks: 'Tasks',
  template_details: 'Details',
  template_tf_workspaces: 'Workspaces',

  // Role-related translations
  slug: 'Slug',
  slug_required: 'Slug is required',
  slugHint: 'Unique identifier (lowercase, alphanumeric, underscores and hyphens only)',
  invalidSlugFormat: 'Slug must be lowercase, alphanumeric with underscores/hyphens only',
  permissions: 'Permissions',
  canRunProjectTasks: 'Can run project tasks',
  canUpdateProject: 'Can update project',
  canManageProjectResources: 'Can manage project resources',
  canManageProjectUsers: 'Can manage project users',
  newRole: 'New Role',
  editRole: 'Edit Role',
  deleteRole: 'Delete Role',
  askDeleteRole: 'Do you really want to delete this role?',
  Roles: 'Roles',
  role_required: 'Role is required',

  templatePermission: 'Template permissions',

  // System Info Dialog
  systemInfo: 'System Information',
  system: 'System',
  version: 'Version',
  goVersion: 'Go Version',
  gitClient: 'Git Client',
  tmpPath: 'Temp Path',
  homeDirMode: 'Home Dir Mode',
  scheduleTimezone: 'Schedule Timezone',
  ansibleNotFound: 'Ansible not found on this server',
  database: 'Database',
  dbDialect: 'Dialect',
  authentication: 'Authentication',
  passwordLogin: 'Password Login',
  emailOtp: 'Email OTP',
  oidcProviders: 'OpenID Connect',
  notifications: 'Notifications',
  cluster: 'Cluster',
  highAvailability: 'High Availability',
  nodeId: 'Node ID',
  nodeCount: 'Node Count',
  uiInstances: 'UI Instances',
  useRemoteRunner: 'Remote Runners',
  globalRunners: 'Global Runners',
  active2: 'active',
  taskSettings: 'Task Settings',
  maxParallelTasks: 'Max Parallel Tasks',
  maxTaskDuration: 'Max Task Duration',
  maxTasksPerTemplate: 'Max Tasks per Template',
  unlimited: 'Unlimited',
  featureFlags: 'Feature Flags',
  nonAdminCanCreateProject: 'Non-admin Can Create Project',
};
